import { render, staticRenderFns } from "./BrokersRequests.vue?vue&type=template&id=11ecc25f"
import script from "./BrokersRequests.vue?vue&type=script&lang=js"
export * from "./BrokersRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports